export default __webpack_public_path__ + "static/media/whitepapertwelve.34ea3512.png";